// extracted by mini-css-extract-plugin
export default {"highlight":"ApplicationSidbar_highlight__iqMs+","invactive":"ApplicationSidbar_invactive__IzApH","sidebar-section":"ApplicationSidbar_sidebar-section__PxWG4"};